<template>
  <el-container class='box'>
    <div class="header">
      <div class="text"><span>运营管理 / 外链链接 / </span><span>外链详情</span>
        <el-button type="primary" size="small" @click="returnBack">返回</el-button>
      </div>

    </div>
    <el-main class="content">
      <el-form ref="addForm" v-if="edit" style="width:50%" @submit.native.prevent :model="information1"
        label-width="140px" :rules="rules">
        <el-form-item label="链接名称：" prop="name">
          <el-input :disabled="!edit" placeholder="请输入链接名称" v-model="information1.name" maxlength="30"></el-input>
        </el-form-item>
        <!-- <el-form-item label="主适配病种：" prop="diseaseTypeId"> -->
        <el-form-item label="主适配病种：">
          <el-select @change="diseaseTypeChange" disabled v-model="information1.diseaseTypeId" filterable
            placeholder="请选择主适配病种">
            <el-option v-for="(item,i) in DiseaseList" :key="i" :label="item.suborderName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对应小程序：" prop="appletId">
          <el-select @change="appletChange" disabled v-model="information1.appletId" filterable placeholder="请选择对应小程序">
            <el-option v-for="item in WeChatAppList" :key="item.appId" :label="item.newName" :value="item.appId">
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="归属：" prop="belongId">
          <el-select disabled v-model="information1.belongId" placeholder="请选择归属" value-key="belongId" filterable>
            <el-option v-for="item in HospitalList" :key="item.belongId" :label="item.belongName"
              :value="item.belongId"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="外链项目：" prop="outsideChainProjectId">
          <el-select v-model="information1.outsideChainProjectId" disabled placeholder="请选择外链项目"
            @change="outsideChainProjectChange">
            <el-option v-for="item in outsideChainProjectList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="渠道：" prop="channelDataList">
          <el-select class="search-input-replay" maxlength="20" v-model="channelDataList" disabled placeholder="请选择渠道"
            multiple clearable filterable remote reserve-keyword  @visible-change='closeDisease'
            @change='onChangeDisease'>
            <el-option v-for="(item,index) in diseaseTypeList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外链问卷：" v-if="information1.outsideChainProjectCode == 'assessmentQuestionnaire'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="openAddQuestion">{{information1.examPaperName?'重新选择':'选择问卷'}}</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链测评：" v-if="information1.outsideChainProjectCode == 'healthTools'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showAddEvaluation=true">选择测评</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链宣教：" v-if="information1.outsideChainProjectCode == 'mission'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showHealthy=true">选择宣教</el-button> -->
          </div>
        </el-form-item>
        <!-- <el-form-item label="外链资讯：" required>
          <div class="box-item">
            <span>请选择资讯</span>
            <el-button type="text" @click="showAddInformation=true">选择资讯</el-button>
          </div>
        </el-form-item> -->
        <el-form-item label="外链医生：" v-if="information1.outsideChainProjectCode == 'doctorTeamDetail'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showDoctor">选择医生</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链服务：" v-if="information1.outsideChainProjectCode == 'teamServiceDetail'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="serviceShow">选择服务</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链落地页：" v-if="information1.outsideChainProjectCode == 'landingPage'" required>
          <div class="box-item">
            <span>{{information1.landingPageName}}</span>
            <!-- <el-button type="text" @click="serviceShow">选择服务</el-button> -->
          </div>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click="resetForm('addForm')">重置</el-button> -->
          <el-button type="primary" v-if="edit" @click="submitForm('addForm')">保存</el-button>
          <el-button type="primary" v-else @click="edit = true">编辑</el-button>
        </el-form-item>
      </el-form>
      <el-form v-else style="width:50%" @submit.native.prevent :model="information1" label-width="140px">
        <el-form-item label="链接名称：" prop="name">
          {{information1.name}}
        </el-form-item>
        <!-- <el-form-item label="主适配病种：" prop="diseaseTypeId"> -->
        <el-form-item label="主适配病种：">
          {{information1.diseaseTypeName}}
        </el-form-item>
        <el-form-item label="对应小程序：" prop="appletId">
          {{information1.appletName}}
        </el-form-item>
        <el-form-item label="归属：" prop="belongId">
          {{information1.belongName}}
        </el-form-item>
        <el-form-item label="外链项目：" prop="outsideChainProjectId">
          {{information1.outsideChainProjectName}}
        </el-form-item>
        <el-form-item label="渠道：">
          {{information1.outsideChainChannelName}}
        </el-form-item>
        <el-form-item label="外链问卷：" v-if="information1.outsideChainProjectCode == 'assessmentQuestionnaire'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="openAddQuestion">{{information1.examPaperName?'重新选择':'选择问卷'}}</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链测评：" v-if="information1.outsideChainProjectCode == 'healthTools'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showAddEvaluation=true">选择测评</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链宣教：" v-if="information1.outsideChainProjectCode == 'mission'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showHealthy=true">选择宣教</el-button> -->
          </div>
        </el-form-item>
        <!-- <el-form-item label="外链资讯：" required>
          <div class="box-item">
            <span>请选择资讯</span>
            <el-button type="text" @click="showAddInformation=true">选择资讯</el-button>
          </div>
        </el-form-item> -->
        <el-form-item label="外链医生：" v-if="information1.outsideChainProjectCode == 'doctorTeamDetail'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="showDoctor">选择医生</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链服务：" v-if="information1.outsideChainProjectCode == 'teamServiceDetail'" required>
          <div class="box-item">
            <span>{{information1.outsideChainChoiceName}}</span>
            <!-- <el-button type="text" @click="serviceShow">选择服务</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="外链落地页：" v-if="information1.outsideChainProjectCode == 'landingPage'" required>
          <div class="box-item">
            <span>{{information1.landingPageName}}</span>
            <!-- <el-button type="text" @click="serviceShow">选择服务</el-button> -->
          </div>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click="resetForm('addForm')">重置</el-button> -->
          <el-button type="primary" v-if="edit" @click="submitForm('addForm')">保存</el-button>
          <el-button type="primary" v-else @click="edit = true">编辑</el-button>
        </el-form-item>
      </el-form>
      <div class="url-box">
        <div class="url-list-item">
          <div>
            <span>{{information1.outsideChainUrlName}}：</span>
            {{information1.shortChainFullPath}}
          </div> 
          <el-button type="primary" size="small" style="margin-left:15px" @click="onAddClick(information1.shortChainFullPath)">复制链接
          </el-button>
          <el-button type="primary" size="small" style="margin-left:15px" @click="showDownLoad(information1)">下载二维码
          </el-button>
        </div>
      </div>

      <addQuestionDialog title="选择问卷" v-if="showAddQuestion" :showAddQuestion.sync="showAddQuestion"
        @receiveQuestion="receiveQuestion" />
      <!-- 宣教弹框 -->
      <healthEducationContent v-if="showHealthy" :showHealthy.sync="showHealthy" @receiveArticle="receiveArticle"
        :showCompanyBtn="true" :hospitalId="hospitalId" />
      <!-- 发送服务 -->
      <service v-if="serviceRecommon" :belongDataList='belongDataList' :showAddQuestion.sync="serviceRecommon"
        :topHospitalId="hospitalId" @assessmentSend="assessmentSend" />
      <evaluation title="选择测评" v-if="showAddEvaluation" :showAddEvaluation.sync="showAddEvaluation"
        @receiveEvaluation="receiveEvaluation" />
      <!-- <information title="选择资讯" v-if="showAddInformation" :showAddInformation.sync="showAddInformation"
      @receiveInformation="receiveInformation" /> -->
      <choiseDoctor title="选择医生团队" :belongDataList='belongDataList' v-if="showAddDoctor"
        :showAddDoctor.sync="showAddDoctor" @receiveDoctor="receiveDoctor" />
    </el-main>
    <downCode ref='code' :curRow='curRow' />
  </el-container>
</template>

<script>
import addQuestionDialog from "../ToolMaintenance/component/addQuestionDialog";
import service from "./component/service";
import choiseDoctor from "./component/choiseDoctor";
import evaluation from "./component/evaluation";
import information from "./component/information";
import local from "@/utils/local.js";
import healthEducationContent from "@/views/ToolMaintenance/component/healthEducationContent";
import {
  getWeChatAppList,
  outsideChainPage,
  outsideChainProjectPage,
  updateChain,
  findIcdDiseaseList,
  getChain,
  getBelongForOutsideChain,
  getByIdChain,
  // getBelongForOutsideChain
} from "./api";
import { page } from "./api/channelManagement";
export default {
  components: {
    addQuestionDialog,
    healthEducationContent,
    service,
    evaluation,
    information,
    choiseDoctor,
    downCode: () => import("./component/downcode.vue")
  },
  props: {},
  data() {
    return {
      curRow: {},
      showAddressList: [],
      serviceRecommon: false,
      edit: false,
      showAddInformation: false,
      showAddQuestion: false,
      showAddDoctor: false,
      showAddEvaluation: false,
      showHealthy: false,
      hospitalId: local.get("patientSchemeHospitalId"),
      information1: {
        outsideChainChoiceId: "",
        outsideChainChoiceName: "",
        appletId: "",
        appletName: "",
        diseaseTypeId: "",
        diseaseTypeName: "",
        name: "",
        belongDataList: [],
        belongId: "",
        outsideChainProjectCode: "",
        outsideChainProjectId: "",
        outsideChainProjectName: "",
        landingPageName:'',
        requiredParamData: {
          hospitalId: "",
          doctorTeamId: "",
          teamServiceId: "",
          doctorSchemeId: "",
          missionId: "",
          examPaperId: ""
        },

        examPaperName: "",
        educationName: "",
        EvaluationName: "",
        doctorName: "",
        serviceName: ""
      },
      load: false,
      success: false,
      belongDataList: [],
      rules: {
        name: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        diseaseTypeId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        appletId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        belongId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ],
        outsideChainProjectId: [
          { required: true, message: "该项为必填项", trigger: "change" }
        ]
      },
      WeChatAppList: [],
      outsideChainProjectList: [],
      DiseaseList: [],
      HospitalList: [],
      outsideChainChannelNameList: [],
      diseaseTypeList: [],
      codeLoading: false,
      diseaseObj: {
        size: 10,
        current: 1,
        name: null,
        enabled: 1
      },
      diseaseTypePages: 1,
      channelDataList: []
    };
  },
  watch: {},
  computed: {},
  directives: {
    selectLoadmore: {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function() {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  methods: {
    showDownLoad(row) {
      this.curRow = row;
      this.$refs.code.showDialogCode();
    },
    closeDown() {
      this.dialogVisible = false;
    },
    getDetail() {
      getChain(this.$route.query.id)
        .then(result => {
          console.log(result.data,"result.data");
          this.information1 = result.data;
          if(result.data && result.data.outsideChainChannelName){
            this.channelDataList.push(result.data.outsideChainChannelName);
          }        
          console.log(this.channelDataList,"sss");  
          this.appletChange(result.data.appletId);
          if(this.$route.query.outsideChainChoiceId){
            this.getByIdChainRequest();
          }

        })
        .catch(err => {});
    },
    getByIdChainRequest(){
      console.log(this.$route.query.outsideChainChoiceId,"this.$route.query.outsideChainChoiceId");
      getByIdChain(this.$route.query.outsideChainChoiceId).then(res => {
        if(res.code == 0){
            this.information1.landingPageName = res.data.name;
            this.$forceUpdate();
        }
      })
    },
    onAddClick(data) {
      this.$copyText(data)
        .then(result => {
          this.$message.success("复制成功");
        })
        .catch(err => {});
    },
    showDoctor() {
      this.belongDataList = this.information1.belongDataList.map(item => {
        return {
          platformType: item.platformType,
          belongId: item.belongId
        };
      });
      this.showAddDoctor = true;
    },
    serviceShow() {
      this.belongDataList = this.information1.belongDataList.map(item => {
        return {
          platformType: item.platformType,
          belongId: item.belongId
        };
      });
      this.serviceRecommon = true;
    },
    appletChange(v) {
      let a = this.WeChatAppList.filter(item => {
        return item.appId == v;
      });
      this.information1.appletName = a[0].newName;

      getBelongForOutsideChain({
        platformType: a[0].platformType,
        belongId: a[0].belongId
      })
        .then(result => {
          this.HospitalList = result.data;
          let s = result.data.filter(i => {
            return i.id == this.information1.belongId;
          });
        })
        .catch(err => {});
    },
    outsideChainProjectChange(v) {
      let a = this.outsideChainProjectList.filter(item => {
        return item.id == v;
      });
      this.information1.outsideChainProjectCode = a[0].code;
      this.information1.outsideChainProjectName = a[0].name;
      this.information1.outsideChainProjectUrl = a[0].path;
      // this.information1.hospitalId = '';
      // this.information1.doctorTeamId='';
      // this.information1.teamServiceId = '';
      // this.information1.doctorSchemeId = '';
      // this.information1.missionId = '';
      // this.information1.examPaperId='';
    },
    openAddQuestion() {
      this.showAddQuestion = true;
    },
    assessmentSend(data) {
      this.serviceRecommon = false;
      this.information1.requiredParamData.doctorTeamId = data.doctorTeamId;
      this.information1.requiredParamData.teamServiceId = data.id;
      this.information1.requiredParamData.doctorSchemeId = data.doctorSchemeId;
      this.information1.outsideChainChoiceName = data.name;
      this.information1.outsideChainChoiceId = data.id;
      this.information1.serviceName = data.name;
    },
    // 接收添加的问卷
    receiveQuestion(data) {
      this.information1.requiredParamData.examPaperId = data.id;
      this.information1.examPaperName = data.title;
      this.information1.outsideChainChoiceName = data.title;
      this.information1.outsideChainChoiceId = data.id;
    },
    receiveEvaluation(data) {
      this.information1.EvaluationName = data.title;
      this.information1.requiredParamData.examPaperId = data.id;
      this.information1.outsideChainChoiceName = data.title;
      this.information1.outsideChainChoiceId = data.id;
    },
    receiveDoctor(data) {
      this.information1.doctorName = data.name;
      this.information1.requiredParamData.hospitalId = data.hospitalId;
      this.information1.requiredParamData.doctorTeamId = data.id;

      this.information1.outsideChainChoiceName = data.name;
      this.information1.outsideChainChoiceId = data.id;
    },
    receiveInformation(data) {},
    // 接收宣教
    async receiveArticle(row) {
      this.information1.educationName = row.title;
      this.information1.requiredParamData.missionId = row.id;

      this.information1.outsideChainChoiceName = row.title;
      this.information1.outsideChainChoiceId = row.id;
      this.showHealthy = false;
    },
    diseaseTypeChange(v) {
      let a = this.DiseaseList.filter(item => {
        return (item.id = v);
      });
      if(a.length > 0){
        this.information1.diseaseTypeName = a[0].suborderName;
      }
      
    },
    submitForm(formName) {
      if (this.load) {
        return;
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.information1.name.trim()) {
            return this.$message.info("名称不能为空");
          }
          this.load = true;
          updateChain(this.information1)
            .then(result => {
              // this.success = true;
              // this.showAddressList = result.data;
              this.getDetail();
              this.$message.success("操作成功");
              this.edit = false;
              this.load = false;
            })
            .catch(err => {
              this.load = false;
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.information1 = this.$options.data().information1;
    },
    returnBack() {
      this.$router.go(-1);
    },
    //获取渠道
    getDiseaseTypeList(key) {
      let params = this.diseaseObj;
      if (key) {
        this.diseaseObj.current = 1;
        this.diseaseTypeList = [];
        this.codeLoading = true;
      }
      setTimeout(() => {
        page(params).then(res => {
          this.codeLoading = false;
          this.diseaseTypePages = res.data.pages;
          this.diseaseTypeList = this.diseaseTypeList.concat(res.data.records);
        });
      }, 200);
    },
    //下拉渠道
    loadmoreDiseaseType() {
      this.diseaseObj.current++;
      if (this.diseaseObj.current > this.diseaseTypePages) {
        return;
      }
      this.getDiseaseTypeList();
    },
    //搜索渠道
    remoteDiseaseType(query) {
      this.diseaseObj.name = query;
      this.diseaseObj.current = 1;
      this.getDiseaseTypeList(true);
    },
    //下拉渠道
    loadmoreDiseaseType() {
      this.diseaseObj.current++;
      if (this.diseaseObj.current > this.diseaseTypePages) {
        return;
      }
      this.getDiseaseTypeList();
    },
    closeDisease(val) {
      if (!val) {
        this.diseaseObj.name = "";
      } else {
        this.getDiseaseTypeList(true);
      }
      // if (!this.listQuery.diseaseTypeId) {
      //   this.diseaseTypeList = [];
      // }
    },
    FilterDataNo(a, b) {
      //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
      var result = new Array();
      var c = b;
      for (var i = 0; i < a.length; i++) {
        if (c.indexOf(a[i].id) >= 0) {
          result.push(a[i]);
        }
      }
      return result;
    },
    onChangeDisease(e) {
      let arrFilter = this.FilterDataNo(this.diseaseTypeList,this.channelDataList);
      this.information1.channelDataList = arrFilter.map(item => {
        return {
          outsideChainChannelId: item.id,
          outsideChainChannelName: item.name
        };
      });
    }
  },
  created() {
    this.hospitalId = local.get("patientSchemeHospitalId");

    getWeChatAppList(1)
      .then(result => {
        this.WeChatAppList = result.data;
        this.getDetail();
        
      })
      .catch(err => {});
    outsideChainProjectPage({})
      .then(result => {
        this.outsideChainProjectList = result.data;
      })
      .catch(err => {});

    findIcdDiseaseList("")
      .then(result => {
        this.DiseaseList = result.data;
      })
      .catch(err => {});
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/.el-select {
  width: 100%;
}
.header {
  background: #fff;

  .text {
    padding: 24px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 20px;
    // border-bottom: 16px solid #F8F8F8;
    display: flex;
    align-items: center;
    span:nth-child(2) {
      color: #333;
      flex: 1;
    }

    span:nth-child(1) {
      color: #999;
    }
  }
}
.content {
  background: #fff;
  margin: 20px;
  padding: 34px;
  .box-item {
    padding: 0 16px;
    display: flex;
    span {
      flex: 1;
    }
  }
  .url-box {
    margin-top: 80px;

    .url-list-item {
      margin-top: 20px;
      display: flex;
      align-items: center;
      div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 500px;
      }
      span {
        margin-right: 20px;
      }
    }
  }
}
</style>